module.exports = "/_next/static/images/customer-review-sarah2-min-37b64a4ca5c9ec4e12aafc39e845389a.png.webp";